import { computed } from 'vue'
import { useMainStore } from '@/composables/store'
import { useSiteTemplate } from '@/composables/useSiteTemplate'
import { parseSiteConfigData } from '@/utils/siteSeo'
import { shouldHideStorefrontLogin } from '@/utils/storefrontLogin'

export function useStorefrontLogin() {
  const store = useMainStore()
  const { templateKey } = useSiteTemplate()
  const loginEnabled = computed(() => !shouldHideStorefrontLogin(
    parseSiteConfigData(store.getSiteInfo()?.configData),
    templateKey.value,
  ))
  return { loginEnabled }
}
